import React, { useEffect, useState } from 'react'
import Filter from '../admin/Filter'
import BorrowerDashboardMain from './BorrowerDashboardMain'

const BorrowerDashboard = () => {
  const [userData, setuserData] = useState([])
  const borroweruserid = localStorage.getItem('borroweruserid')
  // ============================
  // ====Dashboard API=======
  // ============================
  useEffect(() => {
    var myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')

    var raw = JSON.stringify({
      userId: borroweruserid
    })

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    }

    fetch(`https://bizfinn.co.in/getProfile`, requestOptions)
      .then(response => response.json())
      .then(result => {
        console.log(result)
        setuserData(result?.data[0])
      })
      .catch(error => console.log('error', error));
  }, [])

  return (
    <BorrowerDashboardMain>
      <section className="side_content_main_box">
        <div className="page_heading_div">
          <div className="back_btn_filter_main">
            <h2>Dashboard</h2>
            <Filter />
          </div>
        </div>
        <section className="dashboard_boxes_main_section">
          <div className='row'>
            <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12'>
              {/* ========Top Row========= */}
              <div className="row">
                <div className=" col-xl-3 col-lg-6 col-md-6 col-sm-12">
                  <div className="dashboard_boxes_single box_bg_1">
                    <h2>Total Cases</h2>
                    <div className='flex'>
                      <h4>{userData.case_logged}</h4>
                    </div>
                  </div>
                </div>
                <div className=" col-xl-3 col-lg-6 col-md-6 col-sm-12">
                  <div className="dashboard_boxes_single box_bg_2">
                    <h2>Inprocess Cases</h2>
                    <div className='flex'>
                      <h4>{userData?.case_pending}</h4>
                    </div>
                  </div>
                </div>
                <div className=" col-xl-3 col-lg-6 col-md-6 col-sm-12">
                  <div className="dashboard_boxes_single box_bg_1">
                    <h2>Fin Y Score</h2>
                    <div className='flex'>
                      <h4>XXX</h4>
                    </div>
                  </div>
                </div>
              </div>

            </div>


          </div>

        </section>
      </section>
    </BorrowerDashboardMain>
  )
}

export default BorrowerDashboard
